<template>
  <v-col cols="12" xl="6">
    <v-container fluid>
      <v-row no-gutters>
        <div class="stats-title">
          <h3>{{ $t(title) }}</h3>
          <v-tooltip
            v-if="tooltip"
            bottom
            :max-width="400"
            nudge-right="100%"
            transition="fade-transition"
            content-class="tooltip-content">
            <template v-slot:activator="{on, attrs}">
              <v-icon class="fa-light fa-circle-info click" color="tertiary" dense v-on="on" v-bind="attrs" />
            </template>
            <span v-html="$t(tooltip)"></span>
          </v-tooltip>
        </div>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" lg="8">
          <CardBarsStack
            :loading="loading"
            :title="$t('honda.dashboard.stats.pre-deliveries.objectives')"
            :sales="data.sales"
            :salesTarget100="data.salesTarget100"
            :salesTarget105="data.salesTarget105"
            :weight="data.salesWeight"
            :weightTarget="data.salesWeightTarget"
            :status="data.salesStatus"
            :lastDelivery="data.lastDelivery" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardGauge
            :loading="loading"
            :title="$t('honda.dashboard.stats.pre-deliveries.with-hp')"
            :current="data.hondaPlus"
            :percent="data.hondaPlusPerc"
            :target="data.hondaPlusTarget"
            :status="data.hondaPlusStatus" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardBarsStack from '@/components/metrics/CardBarsStack.vue'
import CardGauge from '@/components/metrics/CardGauge.vue'

export default defineComponent({
  name: 'StatsPreDeliveries',
  components: {
    CardGauge,
    CardBarsStack,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
})
</script>
